import { Form as FormikForm } from 'formik';
import styled from 'styled-components/macro';
import { space } from '../../../theme/tokens';
export * from './Form';
export { DetailSectionHint } from './Staff';

export const SummaryContainer = styled.section`
  width: 100%;
  margin: 1em 0;
  padding: 1em 1.2em;
  border-radius: 10px;
  border-left: 0.6em solid #2e9e5b;
  background: #e3f5ea;
  color: ${({ theme }) => theme.headerColour};
`;

export const SummaryHeading = styled.h3`
  margin: 0 0 0.5em 0;
  font-size: 1.6rem;
`;

export const SummaryText = styled.p`
  margin: 0;
  font-size: 1.6rem;
  white-space: pre-wrap;
`;

export const SummaryMeta = styled.p`
  margin: 0.5em 0 0 0;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.subHeaderColour};
`;

export const CompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space[3]};
  width: 100%;
`;

export const CompletionForm = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
  width: 100%;
`;

export const CompletionLabel = styled.label`
  font-size: 1.6rem;
  font-weight: 700;
  color: ${({ theme }) => theme.headerColour};
`;

export const CompletionTextAreaContainer = styled.div`
  padding: 0.8em;
  border: 1px solid ${({ theme }) => theme.pendingFill};
  border-radius: 5px;
  background: ${({ theme }) => theme.appBackground};
`;

export const CompletionError = styled.p`
  margin: 0;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.errorMessage};
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1em;
`;

export const HistoryList = styled.ul`
  margin: 1em 0 0 0;
  padding: 0;
  list-style: none;
  font-size: 1.3rem;
  color: ${({ theme }) => theme.subHeaderColour};

  & li {
    margin-bottom: 0.5em;
  }
`;

export const HistoryHeading = styled.h4`
  margin: 1em 0 0.5em 0;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.headerColour};
`;
